import { render, staticRenderFns } from "./OverviewBuilding.vue?vue&type=template&id=3a73e62a&scoped=true&"
import script from "./OverviewBuilding.vue?vue&type=script&lang=js&"
export * from "./OverviewBuilding.vue?vue&type=script&lang=js&"
import style0 from "./OverviewBuilding.vue?vue&type=style&index=0&id=3a73e62a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a73e62a",
  null
  
)

export default component.exports